// React Entidades blocks
import './faqs';
import './faqs-search';
import './ax-images';
import './slider-timeline';
import './slider-awards';
import './slider-notas';
import './slider-posts';
import './ongs/slider-ongs';
import './ongs/table-ongs';
import './entidades/grid-entidades';
import './entidades/table-entidades';
import './entidades/slider-entidades';
import './entidades/scroll-entidades';
import './comercios/slider-comercios';
import './comercios/slider-comercios-grid';
import './comercios/table-comercios';

import VerticalTabs from './wp-vertical-tabs';
import DefaultTabs from './wp-default-tabs';
import CounterController from './wp-counter';

window.addEventListener('DOMContentLoaded', () => {
  new VerticalTabs();
  new DefaultTabs();
  new CounterController();
});